import React from 'react';
import { Card } from 'react-bootstrap';
import MITBanner from '../../../assets/images/mit-banner.jpg';
import SoftwareCoLogo from '../../../assets/images/softwareco-logo.svg';
// import { API_BASE_URL } from '../../../config';
import { formatTimestamp } from '../../../utils/handler';
// import { TOAST_TYPE } from '../../../utils/constant/errorMessage';
// import { notification } from '../../../utils/notification';

const styles = {
  card: {
    width: '320px',
    borderRadius: '15px',
    overflow: 'hidden',
    borderColor: '#1E3A8A',
    boxShadow: '0px 4px 10px rgba(0, 0, 0, 0.2)'
  },
  header: {
    height: '120px',
    backgroundSize: 'cover',
    backgroundPosition: 'bottom right',
    backgroundColor: '#1E3A8A',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    position: 'relative'
  },
  companyName: {
    backgroundColor: 'rgba(0, 0, 0, 0.7)',
    padding: '6px 12px',
    borderRadius: '8px',
    position: 'absolute',
    top: '15px',
    transform: 'translateX(-50%)',
    textAlign: 'center',
    color: '#FACC15', // Yellow Text
    fontSize: '14px',
    fontWeight: '600',
    letterSpacing: '1px',
    textTransform: 'uppercase'
  },
  profileContainer: {
    position: 'relative',
    marginTop: '-45px'
  },
  profileImage: {
    width: '100px',
    height: '100px',
    background: '#fff',
    padding: '5px',
    borderRadius: '50%',
    border: '4px solid #1E3A8A',
    boxShadow: '0 0 10px rgba(0, 0, 0, 0.2)'
  },
  cardTitle: {
    fontSize: '20px',
    fontWeight: '700',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  designation: {
    fontSize: '12px',
    fontWeight: '400',
    textTransform: 'uppercase',
    letterSpacing: '0.5px'
  },
  textDetails: {
    fontSize: '14px',
    fontWeight: '500',
    color: '#374151', // Dark Gray
    letterSpacing: '0.4px'
  },
  textLabel: {
    fontWeight: '600'
  }
};

/* const initialState = {
    loading: false
  }; */

const EmployeeIDCard = ({ employee }) => {
  // const [state, setState] = useState(initialState);

  return (
    <>
      <Card className="shadow-lg" style={styles.card}>
        {/* Header with Background Image */}
        <div
          style={{
            ...styles.header,
            backgroundImage: `url(${MITBanner})`
          }}
        ></div>

        {/* Profile Image & Logo */}
        <div
          className="d-flex justify-content-center position-relative"
          style={styles.profileContainer}
        >
          {/* Company Logo */}
          <img
            src={SoftwareCoLogo}
            alt="Company Logo"
            style={{
              width: '150px',
              height: '150px',
              borderRadius: '50%',
              position: 'relative'
            }}
          />

          {/* Profile Image (Overlapping Logo) */}
          <img
            src={
              employee.photo ||
              'https://hrx-bucket.s3.dualstack.ap-southeast-2.amazonaws.com/logos/avatar-profile.webp'
            }
            alt="Employee"
            style={{
              width: '100px',
              height: '90px',
              borderRadius: '50%',
              position: 'absolute',
              bottom: '30px',
              right: '50%',
              transform: 'translateX(50%)'
            }}
          />
        </div>

        {/* Card Body */}
        <Card.Body className="text-center" style={{ paddingTop: '0px' }}>
          <Card.Title style={styles.cardTitle}>{employee.name}</Card.Title>
          <Card.Subtitle className="mb-3" style={styles.designation}>
            {employee.designation}
          </Card.Subtitle>

          {/* Employee Details */}
          <Card.Text className="small rounded" style={styles.cardDetails}>
            <div className="d-flex flex-column align-items-center">
              <div className="row w-100 position-relative text-center">
                <div className="col-6 py-3 pe-3 border-end border-opacity-50 text-end">
                  <p className="mb-1 text-wrap">Employee ID</p>
                  <p className="mb-0 fw-bold text-dark">{employee.id}</p>
                </div>

                <div className="col-6 py-3 ps-3 border-opacity-50 text-start">
                  <p className="mb-1 text-wrap">Mobile No.</p>
                  <p className="mb-0 fw-bold text-dark">{employee.phone}</p>
                </div>

                <div className="col-6 py-3 pe-3 text-end">
                  <p className="mb-1 text-wrap">Emergency No.</p>
                  <p className="mb-0 fw-bold">{employee.emergencyMobile}</p>
                </div>

                <div className="col-6 py-3 ps-3 text-start">
                  <p className="mb-1 text-wrap">Date of Birth</p>
                  <p className="mb-0 fw-bold text-dark">
                    {employee?.dateOfBirth
                      ? formatTimestamp(employee?.dateOfBirth, 'DD-MM-YYYY')
                      : ''}
                  </p>
                </div>

                <div
                  className="position-absolute start-50 top-50 translate-middle"
                  style={{
                    width: '1px',
                    height: '100%',
                    borderLeft: '1px dashed #FF0000',
                    padding: '0px'
                  }}
                ></div>
                <div
                  className="position-absolute top-50 translate-middle"
                  style={{
                    width: '60%',
                    height: '1px',
                    borderTop: '1px dashed #FF0000',
                    padding: '0px',
                    left: '50%'
                  }}
                ></div>
              </div>
            </div>
          </Card.Text>
        </Card.Body>
      </Card>
    </>
  );
};

export default EmployeeIDCard;
